import React from 'react';
import Button from 'react-bootstrap/Button';
import * as Icon from 'react-bootstrap-icons';

interface CompanyGusButtonProps {
  nip?: string | null;
  readOnly?: boolean;
  isLoading: boolean;
  onClick: () => void;
  title?: string;
  className?: string;
}

const isNipOnlyDigits = (nip?: string | null) =>
  !!nip && /^\d+$/.test(nip.trim());

export const CompanyGusButton: React.FC<CompanyGusButtonProps> = props => {
  if (props.readOnly || process.env.REACT_APP_GUS_ENABLED !== 'on') {
    return null;
  }

  const isReady = isNipOnlyDigits(props.nip) && !props.isLoading;

  return (
    <Button
      variant={isReady ? 'outline-primary' : 'outline-secondary'}
      className={`${props.className || ''} ${isReady ? 'fw-semibold' : ''}`.trim()}
      onClick={props.onClick}
      disabled={!isReady}
      title={props.title || 'Pobierz dane z GUS'}
    >
      {props.isLoading ? (
        <span className="spinner-border spinner-border-sm" role="status" />
      ) : (
        <>
          <Icon.Search /> GUS
        </>
      )}
    </Button>
  );
};
